import React, { useState, useEffect } from 'react';
import { Star } from 'lucide-react';

const testimonials = [
  {
    name: 'Rajesh Sharma',
    role: 'Property Developer',
    content: 'NS 24 delivered exceptional quality on our residential project. Their attention to detail and professional approach exceeded our expectations.',
    rating: 5,
  },
  {
    name: 'Priya Patel',
    role: 'Business Owner',
    content: 'Working with NS 24 was a great experience. They completed our commercial building on time and within budget.',
    rating: 5,
  },
  {
    name: 'Amit Verma',
    role: 'Homeowner',
    content: 'The team at NS 24 was highly professional and skilled. They transformed our vision into reality with their excellent construction work.',
    rating: 5,
  },
  {
    name: 'Neha Gupta',
    role: 'Real Estate Investor',
    content: 'NS 24\'s commitment to quality and timeline adherence is commendable. They\'ve consistently delivered outstanding results across multiple projects.',
    rating: 5,
  },
  {
    name: 'Suresh Mehta',
    role: 'Commercial Developer',
    content: 'Their expertise in construction and project management is unmatched. NS 24 has been our trusted partner for all major developments.',
    rating: 5,
  },
];

const Testimonials = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [displayCount, setDisplayCount] = useState(3);

  // Update display count based on screen size
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setDisplayCount(1);
      } else if (window.innerWidth < 1024) {
        setDisplayCount(2);
      } else {
        setDisplayCount(3);
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Auto slide every 5 seconds
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prevIndex) => 
        (prevIndex + 1) % (testimonials.length - displayCount + 1)
      );
    }, 5000);

    return () => clearInterval(timer);
  }, [displayCount]);

  // Get current testimonials to display
  const getCurrentTestimonials = () => {
    return testimonials.slice(currentIndex, currentIndex + displayCount);
  };

  return (
    <section className="py-20 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Client Testimonials</h2>
          <p className="text-xl text-gray-600">What our clients say about us</p>
        </div>

        <div className="relative overflow-hidden">
          <div
            className="flex transition-transform duration-1000 ease-in-out"
            style={{
              transform: `translateX(-${currentIndex * (100 / displayCount)}%)`,
            }}
          >
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {getCurrentTestimonials().map((testimonial, index) => (
                <div 
                  key={index} 
                  className="bg-gray-50 rounded-lg p-8 shadow-lg transform hover:scale-105 transition-transform duration-300"
                >
                  <div className="flex mb-4">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <Star 
                        key={i} 
                        className="w-5 h-5 text-yellow-400 fill-current" 
                      />
                    ))}
                  </div>
                  <p className="text-gray-700 mb-6 italic">"{testimonial.content}"</p>
                  <div>
                    <p className="font-bold text-gray-900">{testimonial.name}</p>
                    <p className="text-gray-600">{testimonial.role}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Navigation dots */}
          <div className="flex justify-center mt-8 gap-2">
            {[...Array(testimonials.length - displayCount + 1)].map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentIndex(index)}
                className={`h-2 w-2 rounded-full transition-all duration-300 ${currentIndex === index ? 'bg-blue-600 w-4' : 'bg-gray-300'}`}
                aria-label={`Go to slide ${index + 1}`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
